// 40-yard-dash-specific average speed, derived from raw time — never
// stored. This is average speed over the 40-yard distance (the run
// includes acceleration), NOT a top-speed metric — a future GPS-measured
// top speed is a separate, unrelated metric and should never be conflated
// with this number or its label.
//
// mph = 81.8181818 / seconds  (81.8181818 = (40 yards in miles) * 3600s/hr
// = (40/1760) * 3600)
const FORTY_YARD_MPH_CONSTANT = 81.8181818;

export function fortyYardAvgMph(seconds) {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds) || seconds <= 0) return null;
  return Math.round((FORTY_YARD_MPH_CONSTANT / seconds) * 100) / 100;
}
